module.exports = __webpack_public_path__ + "img/arrow-thick.c6ad95ab.svg";